module.exports = __webpack_public_path__ + "img/equipos_informaticos.3d6d2a7a.png";